import { POSTHOG_SCHEMA_VERSION } from '@/lib/posthogIdentity';
import { posthog } from '@/lib/posthog';
import { trackEvent } from '@/lib/trackEvent';

const resolveReportId = (box: HTMLElement): string | undefined => {
  const fromDom = box.closest('[data-report-id]')?.getAttribute('data-report-id')?.trim();
  if (fromDom) return fromDom;
  if (typeof posthog.get_property !== 'function') return undefined;
  const value = posthog.get_property('report_id');
  if (typeof value !== 'string' || !value.trim()) return undefined;
  return value.trim();
};

export const trackBoxToggle = (opened: boolean, box: HTMLElement | null): boolean => {
  if (!box) return false;

  const reportId = resolveReportId(box);
  if (!reportId) return false;

  const section = box.closest('[data-report-section]') as HTMLElement | null;
  const sectionName =
    box.dataset.reportSectionName ||
    section?.dataset.reportSectionName ||
    section?.dataset.reportSection ||
    undefined;
  const boxSectionName = box.dataset.reportBoxSectionName || undefined;

  const properties: Record<string, unknown> = {
    report_id: reportId,
    schema_version: POSTHOG_SCHEMA_VERSION,
  };
  if (sectionName) properties.section_name = sectionName;
  if (boxSectionName) properties.box_section_name = boxSectionName;

  return trackEvent(opened ? 'box_opened' : 'box_closed', properties);
};
